export default __webpack_public_path__ + "static/google-play-badge-2cb4412b86b9a66ed9aabe0258df7bda.png";